/*
  Haven Prints - mobile menu drawer fix. Added 6 August 2026.

  Broadcast 8.1.1 binds a click handler to the mobile menu button that runs
  document.querySelector('[data-drawer]').dispatchEvent(...) with no null check.
  When the drawer element is not in the DOM at tap time the handler throws and
  the menu never opens. Clarity (30 Jul - 6 Aug 2026): this single error was 64%
  of all JavaScript errors on the site.

  This listens in the capture phase, ahead of the theme's own handler:
    - drawer present  -> do nothing, the theme works normally
    - drawer missing  -> stop the throwing handler, then open the menu as soon as
                         the drawer appears (3 second cap)

  To remove: delete this file and its script tag in layout/theme.liquid.
  Upstream fix needed from Presidio Creative in headerComponent.drawerToggleEvent().
*/
(function () {
  'use strict';

  var DRAWER = '[data-drawer]';
  var TOGGLE = '[data-drawer-toggle]';
  var TIMEOUT_MS = 3000;

  function toggleEvent(button) {
    return new CustomEvent('theme:drawer:toggle', {
      bubbles: false,
      detail: { button: button }
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var button = target.closest(TOGGLE);
    if (!button) return;

    if (document.querySelector(DRAWER)) return;

    event.stopPropagation();

    if (typeof window.MutationObserver !== 'function') return;

    var settled = false;
    var timer;

    var observer = new MutationObserver(function () {
      if (settled) return;
      var drawer = document.querySelector(DRAWER);
      if (!drawer) return;
      settled = true;
      observer.disconnect();
      clearTimeout(timer);
      drawer.dispatchEvent(toggleEvent(button));
    });

    timer = setTimeout(function () {
      if (settled) return;
      settled = true;
      observer.disconnect();
    }, TIMEOUT_MS);

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }, true);
})();